import { render, staticRenderFns } from "./LandingTarifs.vue?vue&type=template&id=b09d1500&scoped=true"
import script from "./LandingTarifs.vue?vue&type=script&lang=js"
export * from "./LandingTarifs.vue?vue&type=script&lang=js"
import style0 from "./LandingTarifs.vue?vue&type=style&index=0&id=b09d1500&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b09d1500",
  null
  
)

export default component.exports